import { useMutation } from '@tanstack/react-query';
import { createDraftStudy } from '@/features/studies/domain/studies.api';
import { useNotification } from '@refinedev/core';
import { useTranslation } from 'react-i18next';
import { StudyListItem } from '@aphp-ema/common/study';
import { useCallback } from 'react';

export const useCreateDraftStudy = () => {
  const { open: openNotification } = useNotification();
  const { t } = useTranslation();

  const { mutate, isLoading } = useMutation({
    mutationFn: createDraftStudy,
    onError: (error: Error) => {
      openNotification?.({
        type: 'error',
        message: t('notifications.errorCreatingStudy'),
        description: error.message,
      });
    },
  });

  const createDraft = useCallback(
    ({ onSuccess }: { onSuccess: (study: StudyListItem) => void }) => {
      mutate(void 0, {
        onSuccess: (study) => {
          onSuccess(study);
        },
      });
    },
    [mutate],
  );

  return { createDraft, isLoading };
};
